var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"support-wrapper",attrs:{"href":`mailto:${_vm.getSupportAddress}`,"target":"_blank"}},[_c('BaseIconText',{attrs:{"icon-url":_vm.svgs.ICONS.QUESTION_ENVELOPE}},[_vm._v(" "+_vm._s(_vm.isMobile ? 'Behöver du hjälp?' : _vm.getSupportAddress)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }